module.exports = __webpack_public_path__ + "static/card-actions-dont-2c22e535742c60bff8a70cd96cdfa90a.png";